"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get custom data related with this editor
 * @param core The EditorCore object
 * @param key Key of the custom data
 * @param getter Getter function. If custom data for the given key doesn't exist,
 * call this function to get one and store it if it is specified. Otherwise return undefined
 * @param disposer An optional disposer function to dispose this custom data when
 * dispose editor.
 */
exports.getCustomData = function (core, key, getter, disposer) {
    return (core.customData[key] = core.customData[key] || {
        value: getter ? getter() : undefined,
        disposer: disposer,
    }).value;
};
//# sourceMappingURL=getCustomData.js.map